import { router, setPageContent } from "..";
import { getFarmcamSimRemainingData } from "../api/farmcam-sims_{imsi}";
import { lineChart } from "../device/device_log_chart";
import { locale } from "../locale";
import { state } from "../state";
import { Bulma } from "../view/bulma";
import { centeredBox } from "../view/components";

/**
 * @type {import('navigo').Handler}
 */
async function farmcamSimLogsPage(ctx) {
	if (!ctx || !ctx.data || !ctx.data.imsi) throw "missing ctx.data.imsi";
	const sim = state.farmcamSims[ctx.data.imsi];

	const remainingDataChart = lineChart({
		label: locale.string({
			enGB: "Remaining data",
			deDE: "Verbleibende Daten",
			frFR: "Données restantes",
			svSE: "Återstående data",
		}),
		unit: "MB",
		device: {
			type: "FarmCam SIM",
			serialNumber: sim.Imsi,
		},
		getData: getRemainingData,
	});

	await setPageContent(
		centeredBox(
			"large",
			Bulma.title(sim.Metadata.Name),
			Bulma.subtitle(`IMSI: ${sim.Imsi}`),
			document.createElement("hr"),
			Bulma.title(
				locale.string({
					deDE: "Verbleibende Daten",
					enGB: "Remaining data",
					frFR: "Données restantes",
					svSE: "Återstående data",
				}),
				"is-5",
			),
			remainingDataChart.element,
			Bulma.buttons(
				Bulma.button(
					{
						onClick: () => router.jump(`/devices?id=${sim.Imsi}`),
						styles: ["is-primary"],
					},
					locale.strings.back,
				),
			),
		),
	);

	remainingDataChart.mount();

	/**
	 * @param {Date} from
	 * @param {Date} to
	 * @param {"csv"|"json"|"xlsx"} format
	 * @returns {Promise<import('../device/device_log_chart').DataPoint[]|Blob>}
	 */
	async function getRemainingData(from, to, format) {
		const res = await getFarmcamSimRemainingData(sim.Imsi, {
			from: from.toISOString(),
			to: to.toISOString(),
			format: format,
		});

		if (res instanceof Blob) return res;
		else
			return res.map((log) => ({
				value: log.RemainingData
					? Math.round(log.RemainingData / 1e6)
					: 0,
				timestamp: log.Timestamp,
			}));
	}
}

export { farmcamSimLogsPage };
